import { ValidationErrors, ValidatorFn } from "@angular/forms";
import { AbstractControl } from "@angular/forms";

export function PasswordPolicyValidator(control: AbstractControl): ValidationErrors | null {
  var regexp = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\da-zA-Z])\S{12,20}$/g;
  let test = regexp.test(control.value);
  return test ? null : { 'passwordPolicy': { value: control.value } };
}

export function MemorableWordPolicyValidator(control: AbstractControl): ValidationErrors | null {
  const regexp = /^([A-Za-z]{8,45})$/g;
  let test = regexp.test(control.value);
  return test ? null : { 'memorableWordPolicy': { value: control.value } };
}

export function EmailPolicyValidator(control: AbstractControl): ValidationErrors | null {
  var regexp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/g;
  let test = regexp.test(control.value);
  return test ? null : { 'emailPolicy': { value: control.value } };
}

export function FullnamePolicyValidator(control: AbstractControl): ValidationErrors | null {
  var regexp = /^[A-Za-z]*$/g;
  let test = regexp.test(control.value);
  return test ? null : { 'fullnamePolicy': { value: control.value } };
}

export function PostcodePolicyValidator(control: AbstractControl): ValidationErrors | null {
  let regexp = /^(GIR ?0AA|(?:[A-PR-UWYZ](?:\d\s|\d{2}\s|[A-HK-Y]\d\s|[A-HK-Y]\d\d\s|\d\s[A-HJKSTUW]|[A-HK-Y]\d\s[ABEHMNPRV-Y])) ?\d[ABD-HJLNP-UW-Z]{2})$/i;
  let test = regexp.test(control.value);
  return test ? null : { 'postcodePolicy': { value: control.value } };
}

export function WhitespaceValidator(control: AbstractControl): ValidationErrors | null {
  let test = (control.value || '').trim().length !== 0;
  return test ? null : { 'whitespacePolicy': { value: control.value } };
}
